import { render } from "./App.vue?vue&type=template&id=fb94b930"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fb94b930&lang=css"

import exportComponent from "/home/josearpaia/Documentos/etyalab/cositas-en-vue/api-banderas-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__